<template lang="pug">
  #app.container-fluid
    transition(name="fade", mode="out-in", appear)
      router-view
</template>

<script>
import titleChanger from './components/visibility'
export default {
  name: 'app',
  mounted(){
    titleChanger()
  }
}
</script>

<style lang="scss">
  @import './assets/css/bootstrap/css/bootstrap.css';
  @import './assets/css/global';

  // .route-item {
  //   transform:translateX(0vh);
  // }

  .fade{

    &-enter{
      transform:translateY(100vh);
      &-active{
        transition: opacity 1s ease-out;
        opacity:0;
      }
      &-to{
        opacity: 1;
      }
    }

    &-leave{
      transform:translateY(0vh);
      &-active{
        transition: opacity 1s ease-in;
        opacity:1;
      }
      &-to{
        opacity:0;
      }

    }

  }
  .route2{

    $duration:500ms;

    &-enter{
      transform:translateX(100vw);
      &-active{
        transition: transform $duration;
        transform:translateX(0vw);

      }
      &-to{
        transform:translateX(0vw);
      }
    }

    &-leave{
      transform:translateX(0vw);
      &-active{
        transition: transform $duration;
        transform:translateX(0vw);

      }
      &-to{
        transform:translateX(-100vw);
      }

    }

  }
  html{
    // cursor: url('./assets/diamond-cursor.ico'), default;
    // cursor:none !important;
    font-family:'futura';
    font-size:16px;
    background-color:white;
    // background-image: url(./assets/nightsky_sml.jpg);
    ::selection{
      background-color:black;
      color:white;
      border-radius: 8px;
    }
    body{
      background-color:white;
      // background-image: url(./assets/nightsky_sml.jpg);
      background-size:auto 100vh;

    }
    @include mobile {
      font-size: 20px;
    }
    @include iphone5{
      font-size:24px;
    }
    @include iphone6{
      font-size:23px;
      *{
        font-weight: 100;
        text-rendering:optimizeLegibility;
        -webkit-font-feature-settings: "kern" 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?5a933d77